import { filterInitialState } from './index';

const matchesInActiveTab = state => state.matches[state.activeTab];
const isLoadingMatches = state => state.isLoadingMatches;
const isLoadingStatusCounts = state => state.isLoadingStatusCounts;
const isLoadingMatchesPage = state =>
  (state.isLoadingMatches || state.isLoadingStatusCounts) ?? true;
const activeTab = state => state.activeTab;
const initialMatchStatusCounts = state => state.initialMatchStatusCounts;
const matchStatusCounts = state => state.matchStatusCounts;
const newMessagesAndUpdatedCount = state =>
  state.initialMatchStatusCounts?.unread +
  state.initialMatchStatusCounts?.updated;
const newMatch = state => state.newMatch;
// AB test 'one-match-per-week': the date when the freemium user can
// unlock a chat again, straight from the /api/matches/v2/:id/summary
// response (unlockMatchAvailableAt). Three states the consumers rely
// on: undefined = no summary has answered yet (say nothing); null =
// loaded with no date (an unlock is available now); date string = the
// cooldown is running.
const unlockMatchAvailableAt = state => {
  const counts = state.matchStatusCounts ?? state.initialMatchStatusCounts;
  if (!counts) return undefined;
  return counts.unlockMatchAvailableAt ?? null;
};
const totalMatchesCount = state =>
  (state.matchStatusCounts?.new ?? 0) +
  (state.matchStatusCounts?.started ?? 0) +
  (state.matchStatusCounts?.inactive ?? 0);
const matchRequests = state => state.matchRequests;
// currentSize for the next page of requests (see setMatchRequestsFetchedCount).
const matchRequestsOffset = state =>
  state.matchRequests?.fetchedCount ?? state.matchRequests?.rooms?.length ?? 0;
const isLoadingMatchRequests = state => state.isLoadingMatchRequests;
const filter = state => state.filter;
const activeToggleTab = state => state.activeToggleTab;
const matchesHasMore = state => state.matchesHasMore;
const filterCount = state => {
  return Object.keys(filterInitialState).reduce((count, key) => {
    return state.filter[key] !== filterInitialState[key] ? count + 1 : count;
  }, 0);
};

export default {
  matchesInActiveTab,
  isLoadingMatches,
  isLoadingStatusCounts,
  isLoadingMatchesPage,
  activeTab,
  initialMatchStatusCounts,
  matchStatusCounts,
  newMessagesAndUpdatedCount,
  newMatch,
  unlockMatchAvailableAt,
  totalMatchesCount,
  matchRequests,
  matchRequestsOffset,
  isLoadingMatchRequests,
  filter,
  activeToggleTab,
  matchesHasMore,
  filterCount
};
